import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import Page from '../Page';
import ViewPage from '../ViewPage';

import '../../styles/main.scss';
import '../App/style.scss';

const Pillar = ({ pillar }) => {
  const { contentType } = useParams();
  return (
    <Page>
      <ViewPage pillar={pillar} contentType={contentType} />
    </Page>
  );
};

function mapStateToProps(state) {
  return {
    rootClasses: state.getIn(['ui', 'rootClasses']),
    language: state.getIn(['ui', 'language']),
  };
}

export default connect(mapStateToProps)((Pillar));

